import { __awaiter } from "tslib";
import { loadWebtexte, requestAPI } from "@phoenixreisen/gateway";
import { Store } from "../../../shared/functions/fns.store";
const Model = {
    webtexte: null,
};
export function getWebtexte() {
    return __awaiter(this, void 0, void 0, function* () {
        const categories = ["ma_login__infosatz"];
        return loadWebtexte(categories, "webtexte.ma-login");
    });
}
export function changePassword(username, jwt, pwd) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestAPI("phxauth.mitarbeiter", {
            "remote-addr": "set by backend",
            type: "mitarbeiter-pwd-aendern",
            "benutzer-kennung": username,
            passwort: pwd,
            jwt: jwt,
        });
    });
}
export function resetPhxPasswordViaSMS(username, phone) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestAPI("phxauth.mitarbeiter", {
            type: "mitarbeiter-passwort-sms",
            "remote-addr": "set by backend",
            "benutzer-kennung": username,
            mobilnummer: phone,
        });
    });
}
export function resetPhxPasswordViaEmail(username) {
    return __awaiter(this, void 0, void 0, function* () {
        const host = `${location.protocol}//${location.host}`;
        const path = "/cdn/mitarbeiter/login/#!/zuruecksetzen/temp";
        return requestAPI("phxauth.mitarbeiter-login-email", {
            "benutzer-kennung": username,
            "remote-addr": "set by backend",
            type: "mitarbeiter-login-email",
            "url-template": `${host}/${path}/{jwt}`,
            "webtext-key-body-template": "mitarbeiter_passwort_reset_email__body",
            "webtext-key-subject-template": "mitarbeiter_passwort_reset_email__subject",
        });
    });
}
export function saveCredentials(result, abbr) {
    if (result) {
        const { status, type } = result;
        if (status === "success" || type === "success") {
            Store.set("jwt", result.jwt);
            Store.set("benutzer-kennung", abbr);
            return result;
        }
    }
    throw result;
}
export function authPhx(abbr, pwd) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestAPI("phxauth.auth-mitarbeiter", {
            "benutzer-kennung": abbr,
            passwort: pwd,
        }).then((data) => {
            return saveCredentials(data, abbr);
        });
    });
}
export function requestTwoFactorLoginCode(username, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestAPI("phxauth.versende-two-factor-auth-code-an-mitarbeiter", {
            "remote-addr": "set by backend",
            "two-factor-auth-chan": "SMS",
            "benutzer-kennung": username,
            jwt: jwt,
        });
    });
}
export function loginWithTwoFactorCode(username, code, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestAPI("phxauth.pruefe-mitarbeiter-two-factor-auth-code", {
            "remote-addr": "set by backend",
            "benutzer-kennung": username,
            code: code,
            jwt: jwt,
        }).then((data) => {
            return saveCredentials(data, username);
        });
    });
}
export function authAgency(url, agencyid) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestAPI("phxauth.agentur-login-email", {
            "remote-addr": "set by backend",
            type: "send-agentur-login-email",
            "webtext-key-body-template": "kabinenpraesente__agentur_email__body",
            "webtext-key-subject-template": "kabinenpraesente__agentur_email__subject",
            "agentur-nr": parseInt(agencyid),
            "login-url-template": url,
        });
    });
}
export function authCustomer(customernr, zipcode) {
    return __awaiter(this, void 0, void 0, function* () {
        return requestAPI("phxauth.auth-kunde", {
            "remote-addr": "set by backend",
            "kunden-nr": parseInt(customernr, 10),
            plz: zipcode.toString(),
        }).then((data) => {
            const result = data;
            if (result.status && result.status !== "success") {
                throw result;
            }
            return result;
        });
    });
}
export default Model;
